import Vue from 'ninenine-white-label/Vue';
import Router from 'vue-router';
import store from './store/store';

import Home from './views/Home.vue';
import Teams from './views/Teams.vue';
import JobsList from './views/JobsList.vue';
import Job from './views/Job.vue';
import Subscription from './views/Subscription/Subscription.vue';
import SubscriptionForm from './views/Subscription/SubscriptionForm.vue';
import Tests from './views/Subscription/Tests.vue';
import PendingTests from './views/Subscription/PendingTests.vue';
import OnlineTest from './views/Subscription/OnlineTest.vue';
import CoverTest from './views/Subscription/CoverTest.vue';
import SubscriptionSuccessReturn from './views/SubscriptionSuccessReturn.vue';
import SubscriptionErrorReturn from './views/SubscriptionErrorReturn.vue';
import NotFound from './views/404.vue';
import RegisterProfile from './views/RegisterProfile.vue';
import AcceptHunting from './views/AcceptHunting.vue';
import Profile from './views/Profile.vue';
import EliminatedByQuestions from './views/EliminatedByQuestions.vue';
import UpdateProfile from "@/views/UpdateProfile.vue";
import ReturnTest from './views/Subscription/ReturnTest.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },

    {
      path: '/password-recovery',
      name: 'password-recovery',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.commit('DEVISE_FORM', 'change-password');
        next();
      },
    },

    {
      path: '/InsertCpf',
      name: 'insert-cpf',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.commit('DEVISE_FORM', 'insert-cpf');
        next();
      },
    },

    {
      path: '/times/:teamName',
      name: 'teams',
      component: Teams,
      props: true,
      children: [
        {
          path: ':subTeamName?',
          name: 'subTeam',
          component: Teams,
          children: [
            {
              path: 'vagas',
              name: 'teamsJobsOpen',
              component: Teams,
            },
          ],
        },
      ],
    },

    {
      path: "/vagas",
      name: "jobs",
      component: JobsList,
      props: true
    },

    {
      path: '/vagas/:id',
      name: 'job',
      component: Job,
    },

    {
      path: '/vagas/:id/inscricao',
      component: Subscription,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'ficha',
          component: SubscriptionForm,
          meta: { requiresAuth: true },
        },

        {
          path: 'testes',
          name: 'testes',
          component: Tests,
          meta: { requiresAuth: true },
        },

        {
          path: 'testes-pendentes',
          name: 'pending-tests',
          component: PendingTests,
          meta: { requiresAuth: true },
        },

        {
          path: ':testName/:testId',
          name: 'capa-teste',
          component: CoverTest,
          meta: { requiresAuth: true },
        },

        {
          path: ':headerTestId/teste/:first_question',
          name: 'teste',
          component: OnlineTest,
          meta: { requiresAuth: true },
        },
      ],
    },

    {
      path: '/return_test/:user_id/:source_test_id/:opportunity_id',
      name: 'return-test',
      component: ReturnTest,
    },

    {
      path: '/inscricao',
      name: 'inscricao',
      component: Subscription,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (store.state.user.isAuth) {
          let goTo = to.query.url;
          let indication = to.query.indication ? '&source=indication' : '';

          let uri = goTo.split('/');
          let name = uri[uri.length - 1];
          let id = name.match(/\d+/)[0];
          let already =
            store.state.opportunities.subscriptions.indexOf(id) !== -1;

          if (already == false) {
            window.fbq('track', 'StartRegistration');
            goTo = goTo.replace(
              'https://www.99jobs.com',
              Vue.prototype.DELTA_ENDPOINT
            );
            goTo += `/subscriptions/external_application?candidate_id=${store.state.user.profile.id}&return_url=${window.location.origin}&preview_url=${window.location.pathname}${indication}`;

            location.href = goTo;
          }
        } else {
          next();
        }
      },
    },

    {
      path: '/deixe-seu-perfil',
      name: 'deixe-seu-perfil',
      component: RegisterProfile,
      meta: { requiresAuth: true },
    },

    {
      path: '/accept_hunting/:token',
      name: 'accept_hunting',
      component: AcceptHunting,
    },

    {
      path: '/meu-perfil',
      name: 'meu-perfil',
      component: Profile,
      meta: { requiresAuth: true },
    },

    {
      path: '/erro-inscricao',
      name: 'erro-inscricao',
      component: SubscriptionErrorReturn,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/inscricao-confirmada',
      name: 'inscricao-confirmada',
      component: SubscriptionSuccessReturn,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/inscricao-recusada',
      name: 'inscricao-recusada',
      component: EliminatedByQuestions,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/inscricao-retorno',
      name: 'inscricao-retorno',
      meta: {
        requiresAuth: true,
      },
      beforeEnter: (to, from, next) => {
        if (to.query.status == 200) {
          next(`/inscricao-confirmada?vaga=${to.query.vaga}`);
        } else {
          next(`/erro-inscricao`);
        }
      },
    },

    {
      path: '/linkedin-return',
      name: 'linkedin-return',
      beforeEnter: (to, from, next) => {
        const url_string = window.location.href;
        const url = new URL(url_string);
        const code = url.searchParams.get('code');
        const error = url.searchParams.get('error');

        if (to.query.back_to) {
          localStorage.setItem('back_to', to.query.back_to);
        }

        if (code || error) {
          if (localStorage.getItem('back_to')) {
            let params = window.location.search;
            if (params.indexOf('?code=') !== -1) {
              params = params.replace('?code=', '&code=');
            }
            next(localStorage.getItem('back_to') + params);
          }
        } else {
          const return_url = window.location.origin + '/linkedin-return';
          window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${Vue.prototype.socialIds.linkedin}&redirect_uri=${return_url}&scope=r_liteprofile%20r_emailaddress`;
        }
      },
    },

    {
      path: "/profile_questions_updates/token/:token",
      name: "atualizacao-perfil",
      component: UpdateProfile,
      meta: {
        requiresAuth: true
      },
    },

    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },
  ],

  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          y: 100
        }
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  store.commit('DEVISE_FORM', null);

  if (from.name == null) {
    localStorage.removeItem('allFilters');
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!Vue.prototype.$session.exists()) {
      let { path, query } = from;
      next({
        path: path,
        query: query,
      });

      store.commit('DEVISE_FORM', 'login');
      store.commit('user/SET_NEXT_ROUTE', to);
    } else {
      next();
      store.commit('user/SET_NEXT_ROUTE', null);
    }
  } else {
    next();
  }
});

export default router;
